// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15eAj","col":"styles_col__2rLLZ"};